import { ValueGetterParams } from "ag-grid-community";
import { BULK_IDENTIFIER } from "components/product-collection/product-collection-views/product-collection-grid-view/detail-list/helpers";
import { get } from "lodash";

export const SIMPLE_SUM = ({ getterParams }) => {
    const { api, column }: ValueGetterParams = getterParams;
    let colTotal = 0;

    let isGroup = false;
    api.forEachNodeAfterFilter((rowNode) => {
        // If row group is applied, take the value from the group to avoid recalculation at row level
        if (rowNode.group && !isGroup) {
            isGroup = true;
        }

        if (isGroup && !rowNode.group) {
            return;
        } else if (!isGroup && rowNode.group) {
            return;
        }

        // Check to see if this for a size then skip the bulk row
        const dataType = get(rowNode, "data.type");
        if (dataType === BULK_IDENTIFIER) {
            return;
        }

        const val = api.getValue(column, rowNode) ?? 0;
        colTotal += +val;
    });
    if (colTotal === 0) {
        return undefined;
    }
    return colTotal;
};
